var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wp-group",class:{ 'wp-group_flat': _vm.flat }},[(_vm.label)?_c('WPInputLabel',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{staticClass:"wp-group__content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }